// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextActivities } from '../Project.context';

// mui
import { Container, Grid, Typography } from '@mui/material';

// tables
import { TableActivities } from '../../../tables/cards/TableActivities/TableActivities';

export const Activities = () => {
	// hooks
	const { t } = useTranslation();

	// context
	const { activities, isLoadingActivities, paginationActivities, refetchActivities } =
		useContext(ContextActivities);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h2">{t('activities')}</Typography>
				</Grid>
				<Grid item xs={12}>
					<TableActivities
						activities={activities}
						isLoading={isLoadingActivities}
						pagination={paginationActivities}
						refetchActivities={refetchActivities}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
